<template>
  <div id="InstitutionsDetailsView" class="page">
    <BaseBreadcrumb :items="breadcrumbItems" />
    <div class="institution-details">
      <div class="institution-details-container">
        <template v-if="isLoading && isLoadingUnits">
          <InstitutionDetailsSkeleton />
        </template>
        <template v-else>
          <InstitutionDetails />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import InstitutionDetails from '../components/Institution/InstitutionDetails.vue';
import InstitutionDetailsSkeleton from '../components/Institution/InstitutionDetailsSkeleton.vue';

export default {
  name: 'InstitutionDetailsView',
  components: {
    InstitutionDetails,
    InstitutionDetailsSkeleton,
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: 'Home',
          link: '/',
        },
        {
          text: 'Especialistas e Clínicas',
          link: '/clinicas',
        },
        {
          text: 'Clínica',
        },
      ],
    };
  },
  mounted() {
    this.getInstitution();
    this.getInstitutionUnits();
  },
  methods: {
    ...mapActions('institutions', ['fetchInstitution', 'fetchInstitutionUnits']),

    async getInstitution() {
      await this.fetchInstitution(this.institutionId);
    },
    async getInstitutionUnits() {
      await this.fetchInstitutionUnits(this.institutionId);
    }
  },
  computed: {
    ...mapGetters('institutions', ['isLoading', 'isLoadingUnits']),

    institutionId() {
      return this.$route.params.id;
    },
  }
};
</script>
